<template>
    <div>
        <a target="_blank" :href=downloadURL rel="noopener noreferrer">
            <p>打开下载页</p>
        </a>
    </div>
</template>

<script>
export default {
    name: 'DownloadIndex',
    computed: {
        // 原来的下载也使用的当前页面的路径，转发到新版的地址上
        downloadURL() {
            return "http://wap.ct.niumumu.com/download"
        }
    },
    mounted() {
        window.location.href = this.downloadURL
    }
}
</script>
<style scoped>
a {
    color: #000000;
    text-decoration: none;
}

p {
    clear: both;
    text-align: center;
    width: 100%;
    font-size: 20px;
    margin-top: -100px;
    margin-left: auto;
    margin-right: auto;
}
</style>
